<template>
  <layout-main-inner title="编辑批次">
    <el-button
      slot="action"
      type="primary"
      :loading="loading"
      @click="save">保存</el-button>
    <template slot="append">
      <span
        v-if="userPermission.SUPERVISE || userPermission.OPERATE"
        style="color:#888">({{ batchInfo.vendorName }})</span>
    </template>
    <product-info
      :loading="loading"
      :product="product" />

    <batch-form-dz
      v-if="product.tagType === 1"
      ref="form"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-pm
      v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 1 "
      ref="form"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-pm-no-tag
      v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 9 "
      ref="form"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-pm-ck
      v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 2 "
      ref="form"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-tm
      v-if="product.tagType !== 1 && batchInfo.tagModel === 2 && product.codingType === 1 "
      ref="form"
      :loading="loading"
      :batch="batchInfo"
      :tag="tagInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-tm-ck
      v-if="product.tagType !== 1 && batchInfo.tagModel === 2 && product.codingType === 2 "
      ref="form"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />
    <template slot="footer">
      <!-- <back-button ref="back" /> -->
      <!-- <el-button
        type="primary"
        :loading="loading"
        @click="save">保存</el-button> -->
    </template>
  </layout-main-inner>
</template>
<script>
import ProductInfo from './busi/product-info.vue'
import batchFormDz from './busi/batch-form-dz.vue'
import batchFormPm from './busi/batch-form-pm.vue'
import batchFormPmNoTag from './busi/batch-form-pm-no-tag.vue'
import batchFormTm from './busi/batch-form-tm.vue'
import batchFormPmCk from './busi/batch-form-pm-ck.vue'
import batchFormTmCk from './busi/batch-form-tm-ck.vue'
// import Utils from './busi/utils.js'
import { mapState } from 'vuex'
import TemplateFormat from '@/utils/templateFormat'
export default {
  name: 'BatchUpdate',
  components: { ProductInfo, batchFormDz, batchFormPm, batchFormPmNoTag, batchFormTm, batchFormPmCk, batchFormTmCk },
  props: {},
  data() {
    return {
      loading: false,
      batchInfo: {},
      product: {},
      tagInfo: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  watch: {},
  mounted() {
    this.getBatch({
      vendorId: this.$route.query.vendorId,
      batchId: this.$route.query.batchId
    })
    this.getproduct({
      vendorId: this.$route.query.vendorId,
      productId: this.$route.query.productId
    })
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getBatch(config, cb) {
      this.loading = true
      this.$store.dispatch('batch/getbatch', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.baseFields = TemplateFormat.editTemplateFormat(res.data.baseFields)
          res.data.extraFields = TemplateFormat.editTemplateFormat(res.data.extraFields || [])
          this.batchInfo = {
            ...this.batchInfo,
            ...res.data
          }
          if (res.data.tagModel === 2 && res.data.codingType === 1) {
            this.tagInfo = {
              tagCount: res.data.tagCount,
              beginTagNo: res.data.beginTagNo,
              endTagNo: res.data.endTagNo
            }
          }
          cb && cb(res.data.productId)
        },
        fail: () => {
          this.loading = false
          this.batchInfo = {}
        }
      })
    },
    getproduct(config) {
      this.loading = true
      this.$store.dispatch('product/getproduct', {
        payload: config,
        success: (res) => {
          this.loading = false
          this.product = res.data
        },
        fail: () => {
          this.loading = false
          this.product = {}
        }
      })
    },
    save() {
      this.$refs.form.submit((res) => {
        this.loading = true
        const postdata = {
          batchId: this.batchInfo.batchId,
          vendorId: this.batchInfo.vendorId,
          productId: this.batchInfo.productId,
          tagModel: this.batchInfo.tagModel,
          codingType: this.batchInfo.codingType,
          isContinous: this.batchInfo.isContinous,
          ...res
        }
        this.$store.dispatch('batch/updatebatch', {
          payload: postdata,
          success: () => {
            this.loading = false
            this.$router.go(-1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus"></style>
